import { ThemeColors } from 'shared/enum';
import styled from 'styled-components';

export const StyledLine = styled.div`
  width: 20px;
  height: 3px;
  background: ${ThemeColors.Primary};
  margin: 7px 0px 7px 0px;
`;
